import ModalHeader from '@/components/modal/ModalHeader.tsx';
import React from 'react';
import Modal from '@/components/modal/Modal.tsx';
import ModalFooter from '@/components/modal/ModalFooter.tsx';
import ActionButton from '@/components/buttons/ActionButton.tsx';
import { FormProvider, useForm } from 'react-hook-form';
import { debugZodResolver } from '@/lib/debugZodResolver';
import {
  CheckboxCustomFieldFormData,
  CheckboxCustomFieldInputData,
  checkboxCustomFieldSchema,
} from '@/features/dashboard/tourCustomFields/schemas/checkboxCustomFieldSchema.ts';
import useCreateCustomField from '@/features/dashboard/tourCustomFields/hooks/useCreateCustomField.ts';
import { tourCustomFieldsRoute } from '@/features/dashboard/tourCustomFields/routes/tourCustomFieldsRoute.ts';
import CheckboxCustomFieldForm from '@/features/dashboard/tourCustomFields/components/CheckboxCustomFieldForm.tsx';
import { FieldType } from '@/components/table/_fieldDefinitions/FieldType.ts';

const CheckboxCustomFieldAddModal = ({ onClose }: { onClose: () => void }) => {
  const { tourId } = tourCustomFieldsRoute.useParams();
  const form = useForm<CheckboxCustomFieldInputData>({
    resolver: debugZodResolver(checkboxCustomFieldSchema),
    defaultValues: {
      type: FieldType.CHECKBOX,
      defaultValue: false,
    },
  });

  const createCustomField = useCreateCustomField(tourId);

  console.log(form.formState.errors);
  const handleSubmit = (data: CheckboxCustomFieldFormData) => {
    createCustomField.mutate(data, {
      onSuccess: () => {
        onClose();
      },
    });
  };

  return (
    <Modal onClose={onClose} isDirty={form.formState.isDirty}>
      <ModalHeader title="Skonfiguruj pole checkbox" onClose={onClose} />
      <FormProvider {...form}>
        <form onSubmit={form.handleSubmit(handleSubmit)}>
          <CheckboxCustomFieldForm />
          <ModalFooter>
            <ActionButton tone="outline" size="sm" onClick={onClose}>
              Zamknij
            </ActionButton>
            <ActionButton tone="accent" size="sm" type="submit">
              Dodaj
            </ActionButton>
          </ModalFooter>
        </form>
      </FormProvider>
    </Modal>
  );
};

export default CheckboxCustomFieldAddModal;
